const TICK_ANGLES = Array.from({ length: 36 }, (_, i) => i * 10)
const ELLIPSE_ANGLES = Array.from({ length: 12 }, (_, i) => i * 30)

export default function AboutOverviewWheel() {
  return (
    <div
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
      aria-hidden="true"
      style={{ width: '115%', height: '115%', zIndex: 0 }}
    >
      <svg
        viewBox="0 0 200 200"
        fill="none"
        stroke="currentColor"
        className="w-full h-full"
        style={{ color: 'rgba(180,83,9,0.18)', animation: 'custom-spin 90s linear infinite' }}
      >
        <circle cx="100" cy="100" r="98" strokeWidth="0.6" />
        <circle cx="100" cy="100" r="82" strokeWidth="0.5" strokeDasharray="1 4" />
        <circle cx="100" cy="100" r="60" strokeWidth="0.5" />
        {TICK_ANGLES.map((deg) => (
          <line key={deg} x1="100" y1="2" x2="100" y2="16" strokeWidth="0.7" transform={`rotate(${deg} 100 100)`} />
        ))}
        {ELLIPSE_ANGLES.map((deg) => (
          <ellipse key={deg} cx="100" cy="40" rx="9" ry="22" strokeWidth="0.45" transform={`rotate(${deg} 100 100)`} />
        ))}
      </svg>
    </div>
  )
}
